import React, { useState } from "react";

import { Menu, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RiShareFill } from "react-icons/ri";

import Button, { Color } from "../../../Form/Button";
import useStyles from "./styles";

const logo = require("../../../../assets/img/logo.svg");

interface Props {
  openShareLinkModal: (open: boolean) => void;
  openShareInventoryModal: (open: boolean) => void;
  openShareEstimateModal: (open: boolean) => void;
}

export const InventoryLogoAndShared = ({
  openShareLinkModal,
  openShareInventoryModal,
  openShareEstimateModal,
}: Props) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <div className={classes.divImage}>
        <img src={logo} alt="company-logo" />
      </div>

      <div>
        <Button
          data-cy="buttonShareLink"
          variant="contained"
          id="share-button"
          aria-haspopup="true"
          customColor={Color.SECONDARY}
          className={classes.button}
          onClick={handleClick}
        >
          <RiShareFill size={16} className="mr-2" />
          {translate("share")}
        </Button>
        <Menu
          id="share-menu"
          className={classes.shareMenu}
          MenuListProps={{
            "aria-labelledby": "share-button",
          }}
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
        >
          <MenuItem
            onClick={() => {
              openShareLinkModal(true);
              handleClose();
            }}
            className={classes.menuItem}
            data-cy="shareVideoSurvey"
          >
            {translate("shareVideoSurvey")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              openShareEstimateModal(true);
              handleClose();
            }}
            className={classes.menuItem}
            data-cy="shareEstimate"
          >
            {translate("shareEstimate")}
          </MenuItem>
          <MenuItem
            onClick={() => {
              openShareInventoryModal(true);
              handleClose();
            }}
            className={classes.menuItem}
            data-cy="shareInventory"
          >
            {translate("shareInventory")}
          </MenuItem>
        </Menu>
      </div>
    </>
  );
};
